<template>
  <div class="activity-submission-page">
    <div class="activity-submission-content">
      <activity-submission-element
        :key="index"
        v-for="(item, index) in submission"
        :elementData="item"
      ></activity-submission-element>
      <div class="feedback-field">
        <label>Add Feedback:</label>
        <fb-rich-text
          v-if="feedback !== null"
          v-model="feedback"
          :uuid="$uuid.v1()"
          :mode="true"
          :element="{ data: { value: feedback } }"
          editor_format="client_full_html"
        />
      </div>
      <div class="rubrics">
        <coach-rubrics
          @messageClassUpdate="msgClassUpdate"
          ref="coachRubrics"
          @update-feedback-uuid="feedbackUuid = $event"
          :feedbackUuid="feedbackUuid"
          :feedback="feedback"
          :form="formType"
          v-if="
            formType === 'go' || formType === 'set' || formType === 'activity'
          "
          :element_uuid="submissionUuid"
          mode="view"
        />
      </div>
    </div>

    <div :class="messageClass" class="no-line justify-content-center">
      <span v-if="messageClass == 'submitted'" class="md-success"
        >Feedback submitted successfully!</span
      >
      <span v-if="messageClass == 'invalid'" class="md-error"
        >Complete the rubric before submitting.</span
      >
    </div>
    <md-button class="submit-rubrics" @click="submitFeedback()"
      >Submit Feedback</md-button
    >
  </div>
</template>
<script>
import CoachRubrics from "./components/CoachRubrics";

export default {
  name: "ActivitySubmission",
  components: {
    CoachRubrics,
  },
  mounted() {
    this.getFeedback().then((data) => {
      if (data && data.length) {
        this.feedback = data[0].attributes.comment && data[0].attributes.comment.value
          ? data[0].attributes.comment.value
          : "";
        this.feedbackUuid = data[0].id;
      }
      else {
        this.feedback = "";
      }
    });
  },
  data() {
    return {
      submission: window.drupalSettings.activitySubmission,
      submissionUuid: window.drupalSettings.activitySubmissionUuid,
      formType: window.drupalSettings.activitySubmissionFormType,
      feedback: null,
      feedbackUuid: null,
      messageClass: "",
    };
  },
  methods: {
    log(msg) {
      console.log(msg);
    },
    msgClassUpdate(classes) {
      this.messageClass = classes;
    },
    submitFeedback() {
      if (
        !this.$refs.coachRubrics.loading &&
        this.$refs.coachRubrics.validate()
      ) {
        this.$refs.coachRubrics.setCoachSubmission();
      } else if (!this.$refs.coachRubrics.validate()) {
        this.msgClassUpdate(this.$refs.coachRubrics.getMessageClass());
      }
    },
    getToken() {
      return fetch("/session/token?t=" + Date.now(), {
        credentials: "include",
      })
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          return text;
        });
    },
    getFeedback() {
      return this.getToken().then((token) => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", token);
        return fetch(
          "/jsonapi/catch_comment/catch_comment?include=user,attached_file" +
            "&filter[element_uuid][condition][path]=element_uuid" +
            "&filter[element_uuid][condition][operator]=IS NULL" +
            "&filter[user.id][value]=" +
            window.drupalSettings.user.uuid +
            "&filter[submission_uuid]=" +
            this.submissionUuid,
          {
            credentials: "include",
            method: "GET",
            headers: fetch_headers,
          }
        )
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            let included = {};
            if (json.included) {
              json.included.forEach((data) => {
                included[data.id] = data;
              });
            }
            let comments = json.data.map((comment) => {
              let userUuid = comment.relationships.user.data.id;
              let files =
                comment.relationships.attached_file &&
                comment.relationships.attached_file.data
                  ? comment.relationships.attached_file.data
                  : null;
              let user = included[userUuid];

              comment.files = [];
              if (files) {
                files.map((file) => {
                  comment.files.push(included[file.id]);
                });
              }
              comment.user = user;

              comment.canDelete =
                window.drupalSettings.user.uid ==
                  user.attributes.drupal_internal__uid ||
                window.drupalSettings.user.uid == 1;

              return comment;
            });
            return comments;
          });
      });
    },
  },
};
</script>
<style lang="scss">
.activity-submission-page {
  .submit-rubrics {
    margin: 0 auto;
    display: flex;
    margin-top: 20px;
    margin-bottom: 20px;
    background: $blue-dark;
    border-radius: 20px;
    font-size: 20px;
    font-weight: bold;
    line-height: 24px;
    color: #ffffff !important;
    height: auto;
  }
  .rubrics {
    margin-left: -25px;
    margin-right: -25px;
  }
  .feedback-field {
    padding-bottom: 10px;
  }
}

.activity-submission-content {
  padding-bottom: 0px !important;
}

.rubrics-content > ul {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.md-success {
  display: block;
  padding: 8px 40px 8px 30px;
  bottom: -50px !important;
  color: rgb(10, 90, 39);
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px !important;
  margin-top: 16px;
  text-align: left;
  font-weight: normal;
  min-height: 40px !important;
  width: 100%;
  background-color: rgb(213, 240, 200);
  border-radius: 32px;
}

.md-error {
  font-size: 16px !important;
}

.not-submitted {
  .md-error {
    display: none;
  }
  .md-success {
    display: none;
  }
}

.submitted {
  .md-error {
    display: none;
  }
  .md-success {
    display: block;
  }
}

.invalid {
  .md-error {
    display: block;
  }
  .md-success {
    display: none;
  }
}
</style>

